export const APP_LINKS = {
  support: {
    label: 'Support',
    path: '/support',
    url: 'https://guffpuff.netlify.app/support',
  },
  deleteAccount: {
    label: 'Delete Account',
    path: '/delete-account',
    url: 'https://guffpuff.netlify.app/delete-account',
  },
};
